import { Card, Typography, Grid, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import formatMoney from 'src/utils/formatMoney';

// Invoiced / outstanding headline + upcoming planned invoices (SC-007 reconciles
// with the B2 invoicing worklist).
export default function CashSection({ cash, currencyLabel }) {
  const navigate = useNavigate();
  if (!cash) return null;
  const upcoming = cash.upcoming || [];

  return (
    <Card sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" fontWeight={600} mb={2}>Cash & Invoicing</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} md={3}>
          <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>Invoiced to Date</Typography>
          <Typography variant="h4" fontWeight={700} color="success.main">{formatMoney(cash.invoiced_to_date, currencyLabel)}</Typography>
        </Grid>
        <Grid item xs={6} md={3}>
          <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>Outstanding</Typography>
          <Typography variant="h4" fontWeight={700} color="warning.dark">{formatMoney(cash.outstanding, currencyLabel)}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" fontWeight={600} mb={0.5}>Upcoming Invoicing</Typography>
          <TableContainer sx={{ maxHeight: 280 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Company</TableCell>
                  <TableCell align="right">Amount</TableCell>
                  <TableCell align="right">Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {upcoming.map((u, idx) => (
                  <TableRow key={`${u.company_id}-${idx}`} hover>
                    <TableCell>
                      <Link component="button" underline="hover" onClick={() => navigate(`/companies/${u.company_id}`)}>
                        {u.company_name}
                      </Link>
                    </TableCell>
                    <TableCell align="right">{formatMoney(u.amount, currencyLabel)}</TableCell>
                    <TableCell align="right">{u.invoicing_date}</TableCell>
                  </TableRow>
                ))}
                {upcoming.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center" sx={{ color: 'text.secondary', py: 2 }}>
                      No upcoming invoices.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Card>
  );
}
